import type {ReactNode} from 'react';

import {Heading} from '@/modules/foundation/components/typography/heading';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = {
	children: ReactNode;
	className?: string;
};

export const Heading2 = ({children, className}: Props) => {
	return (
		<Heading level={2} spacing className={cn([className])}>
			{children}
		</Heading>
	);
};

export const Heading3 = ({children, className}: Props) => {
	return (
		<Heading level={3} spacing className={cn([className])}>
			{children}
		</Heading>
	);
};

export const Heading4 = ({children, className}: Props) => {
	return (
		<Heading level={4} spacing className={cn([className])}>
			{children}
		</Heading>
	);
};

export const Heading5 = ({children, className}: Props) => {
	return (
		<Heading level={5} spacing className={cn([className])}>
			{children}
		</Heading>
	);
};

export const Heading6 = ({children, className}: Props) => {
	return (
		<Heading level={6} spacing className={cn([className])}>
			{children}
		</Heading>
	);
};
